import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import About from './components/About';
import Education from './components/Education';
import Contact from './components/Contact';
import Transportes from './components/Transportes';
import H from './components/H';
import Screensaver from './components/Screensaver';
import Footer from './components/Footer';
import Home from './pages/Home';
import CV from './pages/CV';
import Meme from './pages/Meme';
import PR from './pages/PR';
import './styles/main.css';

function AppContent() {
  const location = useLocation();
  const isHPage = location.pathname === '/h';
  const isScreensaver = location.pathname === '/screensaver';
  const hideHeaderFooter = isHPage || isScreensaver;

  return (
    <div className={`App lg-page${!hideHeaderFooter && location.pathname !== '/' ? ' App--subpage' : ''}`}>
      {!hideHeaderFooter && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/education" element={<Education />} />
        <Route path="/transportes" element={<Transportes />} />
        <Route path="/h" element={<H />} />
        <Route path="/screensaver" element={<Screensaver />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/cv" element={<CV />} />
        <Route path="/meme" element={<Meme />} />
        <Route path="/pr" element={<PR />} />
      </Routes>
      {!hideHeaderFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;